<template>
  <div class="pr-1 sm:overflow-auto md:overflow-hidden lg:overflow-hidden">
    <TableWithCondensedContent
      class="mt-4"
      has-cell-link
      cell-link-text="Go to client"
      :table-headers="['Company', 'Client Contact', 'Latest Project']"
      :table-rows="userClientsRecent.map((client) => {
        return [
          client.name,
          client.contact?.name ?? '-',
          client.latest_project?.name ?? '-',
          route('clients.show', {id: client.id}),
        ];
      })">
      <template #header>
        <Tooltip
          align="left"
          content-class="text-xs italic text-gray-400 hover:text-gray-400 -mb-4 w-max">
          <template #trigger>
            <h2 class="relative w-fit cursor-help text-lg font-medium text-gray-800">
              Your active clients
            </h2>
          </template>
          <template #content>
            Clients where you are set as KAM, that have any projects updated within the last 60 days, excluding those from archived projects.
          </template>
        </Tooltip>
      </template>
    </TableWithCondensedContent>

    <TableWithCondensedContent
      class="my-8"
      has-cell-link
      has-search
      has-paginator
      :items-per-page="10"
      search-placeholder="Search clients"
      cell-link-text="Go to client"
      :table-headers="['Company', 'Client Contact', 'KAM', 'Latest Project']"
      :table-rows="teamClients.map((client) => {
        return [
          client.name,
          client.contact?.name ?? '-',
          client.kam?.name ?? '-',
          client.latest_project?.name ?? '-',
          route('clients.show', {id: client.id}),
        ];
      })">
      <template #header>
        <Tooltip
          class="mb-2 w-fit"
          align="left"
          content-class="text-xs italic text-gray-400 hover:text-gray-400 -mb-4 w-max">
          <template #trigger>
            <h2 class="relative w-fit cursor-help text-lg font-medium text-gray-800">
              Your team's clients
            </h2>
          </template>
          <template #content>
            Every client (including yours) found in your team, <strong>{{ team.name }}</strong>.
          </template>
        </Tooltip>
      </template>
      <template #button>
        <div class="self-end sm:ml-16 sm:flex-none">
          <button
            type="button"
            class="inline-flex items-center justify-center gap-1 rounded-md border
              border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm
              hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
            @click="showCreateForm = !showCreateForm">
            Add new client
          </button>
        </div>
      </template>
    </TableWithCondensedContent>
  </div>
  <div class="relative mt-5 overflow-hidden rounded-lg bg-white shadow" />
  <Modal
    :show="showCreateForm"
    max-width="md"
    :closeable="true"
    @close="showCreateForm = false">
    <CreateClientForm @close="showCreateForm = false" />
  </Modal>
  <div class="relative mt-5 overflow-hidden rounded-lg bg-white shadow" />
</template>

<script setup>
/* external */
import {
  ref, useAttrs,
} from 'vue';
import Modal from '@/Jetstream/Modal.vue';

/* local */
import TableWithCondensedContent from '@/Components/Lists/TableWithCondensedContent.vue';
import Tooltip from '@/Components/Tooltip.vue';
import CreateClientForm from '@/ComponentsDeprecated/CreateClientForm.vue';

/* *********************************************************************
 * Component declarations
 * ****************************************************************** */
defineProps({
  userClientsRecent: {
    type: Array,
    required: true,
    default: () => [],
  },
  teamClients: {
    type: Array,
    required: true,
    default: () => [],
  },
});

const attrs = useAttrs();
const { team } = attrs;

const showCreateForm = ref(false);
</script>
